import ajax from "./ajax.js";
// 栏目列表
export const getMenu = query => {
  return ajax.get("/v1/web/api/node/list", {
    params: query
  });
};
// 文章列表 web
export const getNewsList = query => {
  return ajax.post("/v1/web/api/content/listAll", query);
};
// 文章详情
export const getNewsDetail = query => {
  return ajax.get("/v1/web/api/content/" + query.contentId, {
    params: null
  });
};
// 获取搜索内容
export const getSearchList = (params) => {
  return ajax.post('/v1/web/api/content/search', params)
}
// 获取信息反馈验证码
export const getMessageCheckCode = () => {
  return ajax.get('/v1/api/feedback/verifycode')
}
// 添加信息反馈
export const sendMessage = (params = {}) => {
  return ajax.post('/v1/api/feedback/add', params)
}